import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useCpmsBoGetRevenueQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import { useFilters } from '../../context/filters.context';
import * as css from '../../statistics.module.scss';

export const RevenueCard = (): React.JSX.Element => {
  const { t } = useTranslation();

  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetRevenueQuery({ ...transformedFilters });

  return (
    <Card gap={GapEnum.M} flex={1}>
      <AccentTitle
        variant={AccentVariantEnum.Accent1}
        icon="currency-euro-circle"
        text={t('$.statistics.revenue.revenue.title')}
      />
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedDecorative])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Stack
          alignItems="center"
          gap={GapEnum.XS}
          flex={1}
          justifyContent="flex-start">
          <Text fontSize={TextFontSize.Large}>
            {t('$.statistics.revenue.revenue.average')}
          </Text>
          <Text fontSize={TextFontSize.Medium} color={TextColor.Secondary}>
            {t('$.statistics.revenue.revenue.by-transaction')}
          </Text>
        </Stack>
        <NumberFixed
          bold
          fontSize={TextFontSize.Large}
          number={data?.average ?? 0}
          digits={0}>
          <Text>{t('$.statistics.revenue.revenue.unit')}</Text>
        </NumberFixed>
      </Stack>
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedDecorative])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Text fontSize={TextFontSize.Large}>
          {t('$.statistics.revenue.revenue.minimum')}
        </Text>
        <NumberFixed
          bold
          fontSize={TextFontSize.Large}
          number={data?.minimum ?? 0}
          digits={0}>
          <Text>{t('$.statistics.revenue.revenue.unit')}</Text>
        </NumberFixed>
      </Stack>
      <Stack
        alignItems="center"
        className={classNames([css.highlighted, css.highlightedDecorative])}
        direction="row"
        gap={GapEnum.M}
        justifyContent="space-between">
        <Text fontSize={TextFontSize.Large}>
          {t('$.statistics.revenue.revenue.maximum')}
        </Text>
        <NumberFixed
          bold
          fontSize={TextFontSize.Large}
          number={data?.maximum ?? 0}
          digits={0}>
          <Text>{t('$.statistics.revenue.revenue.unit')}</Text>
        </NumberFixed>
      </Stack>
    </Card>
  );
};
